module.exports = __webpack_public_path__ + "static/img/banner.3846222.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/solutions/smartsite/banner.png
// module id = jziu
// module chunks = 12